import { WidgetHelper } from './Widget';
import { WidgetType } from './widgetType';
export const FillInQuestionHelper = {
    create: (id, trackingIdentifier, questionText, validAnswers, properties, feedback, titleAssetId) => {
        const data = {
            questionText,
            validAnswers,
            feedbackCorrect: feedback.feedbackCorrect,
            feedbackIncorrect: feedback.feedbackIncorrect,
            titleAssetId,
        };
        return WidgetHelper.buildWidget(id, trackingIdentifier, data, properties, WidgetType.fillInQuestion);
    },
    isFillInQuestionWidget: (widget) => {
        return widget.value.type === WidgetType.fillInQuestion;
    },
    isFillInQuestionWidgetServerModel: (widget) => {
        return widget.type === WidgetType.fillInQuestion;
    },
};
